import { useCallback, useEffect, useRef, useState } from "react";
import { useWebSocket } from "@/components/WebSocketProvider";
import { getTargetUrl } from "@/utils";

/**
 * websocket连接
 * @returns
 */
const useChatConnection = () => {
  const { connect, sendMessage, lastMessage, connectionStatus, disconnect } =
    useWebSocket();
  const sseSourceRef = useRef<EventSource | null>(null);
  const [fetchLoading, setFetchLoading] = useState<boolean>(false);
  const baseUrl = getTargetUrl();

  //获取websocket地址
  const getWebsocketHost = () => {
    let host = "";
    if (!baseUrl) {
      const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
      host = `${protocol}//${window.location.host}`;
    } else {
      const resultUrl = baseUrl.replace(/^https?:\/\//i, "");
      host = `wss://${resultUrl}`;
    }
    return host;
  };

  /**
   * 获取websocket请求地址
   * @param agentId
   * @returns
   */
  const getWebSocketUrl = (agentId: any) => {
    return `${getWebsocketHost()}/api/v1/agent/customer/connect?agent=${agentId}`;
  };

  //关闭sse请求
  const closeSSE = useCallback(() => {
    if (sseSourceRef.current) {
      sseSourceRef.current.close();
      sseSourceRef.current = null;
      setFetchLoading(false);
    }
  }, []);

  useEffect(() => {
    return () => closeSSE();
  }, [closeSSE]);

  return {
    lastMessage,
    sseSourceRef,
    fetchLoading,
    baseUrl,
    connectionStatus,
    connect,
    sendMessage,
    setFetchLoading,
    getWebSocketUrl,
    closeSSE,
    disconnect,
  };
};

export default useChatConnection;
